import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { USER_TIMEZONE } from './constants';

dayjs.extend(utc);
dayjs.extend(timezone);

export const DATE_FORMAT = 'DD-MM-YYYY';
export const DATETIME_FORMAT = 'DD-MM-YYYY HH:mm';

/** 
 * Comprueba si es una zona válida de IANA para el navegador. 
 */
const isValidTimezone = (tz) => {
  try {
    Intl.DateTimeFormat(undefined, { timeZone: tz });
    return true;
  } catch {
    return false;
  }
};

/**
 * Zona horaria con la que se muestran las fechas con hora, si no tiene o no es válida, la del navegador.
 */
export const getUserTimezone = () => {
  let tz = null;
  try { 
    tz = localStorage.getItem(USER_TIMEZONE); 
  } catch { 
    console.log("No se pudo recuperar la zona horaria del usuario");
  }
  return tz && isValidTimezone(tz) ? tz : dayjs.tz.guess();
};

/**
 * Zonas horarias IANA disponibles en el navegador.
 */
export const getTimezoneList = () => {
  try {
    const list = Intl.supportedValuesOf('timeZone');
    return list.includes('UTC') ? list : ['UTC', ...list];
  } catch {
    return ['UTC', dayjs.tz.guess()];
  }
};

/**
 * Fecha -> 'DD-MM-YYYY'.
 * - Fecha sin hora ('YYYY-MM-DD', de la BD): se muestra tal cual, sin conversión de zona.
 * - Instante (ISO con hora o Date): día en la zona del perfil del usuario.
 */
export const formatDate = (value) => {
  if (!value) return '';
  const d = isInstant(value) ? dayjs(value).tz(getUserTimezone()) : dayjs(value);
  return d.isValid() ? d.format(DATE_FORMAT) : '';
};

/**
 * Fecha con hora -> 'DD-MM-YYYY HH:mm'
 * Llega de la API como instante ISO en UTC.
 */
export const formatDateTime = (value) => {
  if (!value) return '';
  const d = dayjs(value);
  return d.isValid() ? d.tz(getUserTimezone()).format(DATETIME_FORMAT) : '';
};

/** Para ordenar columnas por fecha (sirve para fechas con y sin hora). */
export const compareDates = (a, b) => dayjs(a || 0).valueOf() - dayjs(b || 0).valueOf();

/** ¿Es un instante (Date o texto ISO con hora) en lugar de una fecha sin hora? */
const isInstant = (value) => value instanceof Date || (typeof value === 'string' && value.includes('T'));
